// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listOfPrograms__text {
    text-align: left;
    display: flex;
    align-items: center;
    text-transform: uppercase;
}

.listOfPrograms__text > span > p {
    margin-bottom: 0;
}

.listOfPrograms__button-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 0px;
}

.listOfPrograms__button-link {
    text-decoration: none;
}

.listOfPrograms__button-btn {
    margin-top: 0px;
}


/* Start - CurrentProgram */

.currentPrograms__title {
    font-size: 32px;
}

.currentPrograms__text {
    text-align: justify;
    padding: 0 30px;
}

.listofPrograms_promoVpo{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
}

.promoVPO_text h3 {
    /* color: #3AC9B5; */
    color: var(--main-green-color);
    text-align: left;
}

.promoVPO_text h3 a{
    /* color: #3AC9B5; */
    color: var(--main-green-color);
    text-align: left;
}

.promoVPO_text p {
    text-align: left;
    font-weight: 600;
}

/* End - CurrentProgram */

@media (max-width: 767px) {
    .currentPrograms__title {
        font-size: 24px;
    }
    .currentPrograms__text {
        padding: 0px;
    }
}

@media (max-width: 575px) {
    .listOfPrograms__title {
        margin-bottom: 20px;
    }
    
    .promoVPO_text h3,
    .promoVPO_text p {
        text-align: center;
    }
    
    .listOfPrograms__text {
        text-align: center;
        display: block;
    }

    .listOfPrograms__button-container {
        justify-content: center;
    }

    .listOfPrograms__button-btn {
        margin-top: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/listOfPrograms.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;;AAGA,2BAA2B;;AAE3B;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,yBAAyB;;AAEzB;IACI;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".listOfPrograms__text {\n    text-align: left;\n    display: flex;\n    align-items: center;\n    text-transform: uppercase;\n}\n\n.listOfPrograms__text > span > p {\n    margin-bottom: 0;\n}\n\n.listOfPrograms__button-container {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-right: 0px;\n}\n\n.listOfPrograms__button-link {\n    text-decoration: none;\n}\n\n.listOfPrograms__button-btn {\n    margin-top: 0px;\n}\n\n\n/* Start - CurrentProgram */\n\n.currentPrograms__title {\n    font-size: 32px;\n}\n\n.currentPrograms__text {\n    text-align: justify;\n    padding: 0 30px;\n}\n\n.listofPrograms_promoVpo{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2rem;\n}\n\n.promoVPO_text h3 {\n    /* color: #3AC9B5; */\n    color: var(--main-green-color);\n    text-align: left;\n}\n\n.promoVPO_text h3 a{\n    /* color: #3AC9B5; */\n    color: var(--main-green-color);\n    text-align: left;\n}\n\n.promoVPO_text p {\n    text-align: left;\n    font-weight: 600;\n}\n\n/* End - CurrentProgram */\n\n@media (max-width: 767px) {\n    .currentPrograms__title {\n        font-size: 24px;\n    }\n    .currentPrograms__text {\n        padding: 0px;\n    }\n}\n\n@media (max-width: 575px) {\n    .listOfPrograms__title {\n        margin-bottom: 20px;\n    }\n    \n    .promoVPO_text h3,\n    .promoVPO_text p {\n        text-align: center;\n    }\n    \n    .listOfPrograms__text {\n        text-align: center;\n        display: block;\n    }\n\n    .listOfPrograms__button-container {\n        justify-content: center;\n    }\n\n    .listOfPrograms__button-btn {\n        margin-top: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
